"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBasicComponentWith = exports.createBasicComponent = void 0;
/* eslint-disable react/prop-types */
var styled_system_1 = require("styled-system");
var should_forward_prop_1 = __importDefault(require("@styled-system/should-forward-prop"));
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var css_1 = require("@emotion/css");
var additional = (0, styled_system_1.system)({
    textDecoration: {
        property: 'textDecoration'
    },
    textTransform: {
        property: 'textTransform'
    },
    gridColumnStart: {
        property: 'gridColumnStart'
    },
    gridColumnEnd: {
        property: 'gridColumnEnd'
    },
    rowGap: {
        property: 'rowGap'
    },
    columnGap: {
        property: 'columnGap'
    },
});
// https://styled-system.com/api/
// styleFn enables component to have props like margin, padding, color...
var styleFn = (0, styled_system_1.compose)(styled_system_1.space, styled_system_1.layout, styled_system_1.typography, styled_system_1.color, styled_system_1.flexbox, styled_system_1.grid, styled_system_1.background, styled_system_1.border, styled_system_1.position, additional);
var StyledBox = styled_1.default.div({
    // reset default css
    boxSizing: 'border-box',
    margin: 0,
    padding: 0
});
var BaseBox = react_1.default.forwardRef(function (props, ref) {
    return (react_1.default.createElement(StyledBox, __assign({}, props, { ref: ref, className: (0, css_1.cx)('ff-ui', props.className), tabIndex: props.tabEnter ? 0 : props.tabIndex, onKeyPress: function (event) {
            var _a;
            if (props.tabEnter && event.key === 'Enter') {
                event.currentTarget.click();
            }
            (_a = props.onKeyPress) === null || _a === void 0 ? void 0 : _a.call(props, event);
        } })));
});
BaseBox.displayName = 'BaseBox';
// use this function to create basic components like button, input, image, link...
function createBasicComponent() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    // apply styleFn at the end so it enables components to override default styles with props
    return (0, styled_1.default)(BaseBox, { shouldForwardProp: shouldForwardProp }).apply(void 0, __spreadArray(__spreadArray([], styles, false), [styleFn], false));
}
exports.createBasicComponent = createBasicComponent;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createBasicComponentWith(component) {
    var styles = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        styles[_i - 1] = arguments[_i];
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, styled_1.default)(component, { shouldForwardProp: shouldForwardProp }).apply(void 0, __spreadArray(__spreadArray([], styles, false), [styleFn], false));
}
exports.createBasicComponentWith = createBasicComponentWith;
function shouldForwardProp(prop) {
    // let 'as' prop pass through, prevent style props such as display, color passing to html attribute
    return prop === 'as' || prop === 'tabEnter' || (0, should_forward_prop_1.default)(prop);
}
var Box = createBasicComponent();
Box.displayName = 'Box';
exports.default = Box;
